module.exports = __webpack_public_path__ + "static/media/check_circle_white.fce7f9a7.svg";